angular.module('app').directive('selectFontawesome', function ($sce) {
    return {
        restrict: 'E',
        template: `
            <select ui-select2="select2Options" ng-model="ngModel">
                <option value=""></option>
                <option ng-repeat="option in options" value="{{option}}">{{option}}</option>
            </select>
        `,
        scope: {
            ngModel: '=',
        },
        controller: function ($scope, $element, $http, $timeout, $compile) {

            $scope.select2Options = {
                theme: "bootstrap",
                templateSelection: (state) => {
                    if (!state.id) {
                        return state.text;
                    }

                    let $state = $(`<span><i class="fa fa-${state.id}"></i> ${state.text}</span>`);
                    return $state;
                },
                templateResult: (state) => {
                    if (!state.id) {
                        return state.text;
                    }

                    let $state = $(`<span><i class="fa fa-${state.id}"></i> ${state.text}</span>`);
                    return $state;
                },
            };

            $scope.options = [
                "address-book",
                "address-card",
                "angry",
                "arrow-alt-circle-down",
                "arrow-alt-circle-left",
                "arrow-alt-circle-right",
                "arrow-alt-circle-up",
                "bell",
                "bell-slash",
                "bookmark",
                "building",
                "calendar",
                "calendar-alt",
                "calendar-check",
                "calendar-minus",
                "calendar-plus",
                "calendar-times",
                "caret-square-down",
                "caret-square-left",
                "caret-square-right",
                "caret-square-up",
                "chart-bar",
                "check-circle",
                "check-square",
                "circle",
                "clipboard",
                "clock",
                "clone",
                "closed-captioning",
                "comment",
                "comment-alt",
                "comment-dots",
                "comments",
                "compass",
                "copy",
                "copyright",
                "credit-card",
                "dizzy",
                "dot-circle",
                "edit",
                "envelope",
                "envelope-open",
                "eye",
                "eye-slash",
                "file",
                "file-alt",
                "file-archive",
                "file-audio",
                "file-code",
                "file-excel",
                "file-image",
                "file-pdf",
                "file-powerpoint",
                "file-video",
                "file-word",
                "flag",
                "flushed",
                "folder",
                "folder-open",
                "frown",
                "frown-open",
                "futbol",
                "gem",
                "grimace",
                "grin",
                "grin-alt",
                "grin-beam",
                "grin-hearts",
                "grin-squint",
                "grin-squint-tears",
                "grin-stars",
                "grin-tears",
                "grin-tongue",
                "grin-tongue-squint",
                "grin-tongue-wink",
                "grin-wink",
                "hand-lizard",
                "hand-paper",
                "hand-peace",
                "hand-point-down",
                "hand-point-left",
                "hand-point-right",
                "hand-point-up",
                "hand-pointer",
                "hand-rock",
                "hand-scissors",
                "hand-spock",
                "handshake",
                "hdd",
                "heart",
                "home",
                "hospital",
                "hourglass",
                "id-badge",
                "id-card",
                "image",
                "images",
                "keyboard",
                "kiss",
                "kiss-beam",
                "kiss-wink-heart",
                "laugh",
                "laugh-beam",
                "laugh-squint",
                "laugh-wink",
                "lemon",
                "life-ring",
                "lightbulb",
                "list-alt",
                "map",
                "meh",
                "meh-blank",
                "meh-rolling-eyes",
                "minus-square",
                "money-bill-alt",
                "moon",
                "newspaper",
                "object-group",
                "paper-plane",
                "pause-circle",
                "play-circle",
                "plus-square",
                "question-circle",
                "redo",
                "redo-alt",
                "registered",
                "sad-cry",
                "sad-tear",
                "save",
                "sync",
                "sync-alt",
                "share-square",
                "smile",
                "smile-beam",
                "smile-wink",
                "snowflake",
                "square",
                "star",
                "star-half",
                "sticky-note",
                "stop-circle",
                "sun",
                "surprise",
                "thumbs-down",
                "thumbs-up",
                "times-circle",
                "tired",
                "trash-alt",
                "user",
                "user-circle",
                "window-close",
                "window-maximize",
                "window-minimize",
                "window-restore",
            ];
        },
        link: function ($scope, $element, attrs, ctrl) {

        }
    };
});